module.exports = __webpack_public_path__ + "static/img/s410.0283b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s410.png
// module id = 562
// module chunks = 3